module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_2-67e272d836b9cf30bdd512ebe9ef034d.svg";